export default __webpack_public_path__ + "static/media/lpm_logo_exact.3e83f68b.png";